import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';

class OfferTemplatesState {
  store = new DomainStore();

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async removeTemplate(template) {
    await this.store.destroy(template);
  }
}

export default OfferTemplatesState;
